import { render, staticRenderFns } from "./CalendariosConfig.vue?vue&type=template&id=57f199fe&scoped=true"
import script from "./CalendariosConfig.vue?vue&type=script&lang=js"
export * from "./CalendariosConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f199fe",
  null
  
)

export default component.exports